interface ICAGR_FORMULA {
  beginningValue: number | undefined;
  endingValue: number | undefined;
  investmentTenure: number | undefined;
}

export const CAGR_FORMULA = ({
  beginningValue,
  endingValue,
  investmentTenure,
}: ICAGR_FORMULA) => {
  if (
    !beginningValue ||
    !endingValue ||
    !investmentTenure ||
    Number(beginningValue) < 0 ||
    Number(endingValue) < 0 ||
    Number(investmentTenure) < 0
  ) {
    return {
      cagr: 0,
    };
  }

  const cagr =
    (Math.pow(
      Number(endingValue) / Number(beginningValue),
      1 / Number(investmentTenure)
    ) -
      1) *
    100;

  return {
    cagr: cagr.toFixed(2),
  };
};
